import { render, staticRenderFns } from "./VettingEditShortlistTalent.vue?vue&type=template&id=d6284c30"
import script from "./VettingEditShortlistTalent.vue?vue&type=script&lang=js"
export * from "./VettingEditShortlistTalent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports